import Box from '@mui/material/Box/Box'

import { COLORS } from 'styles/colors'

import BarchartInfoLogo from 'assets/BarchartInfoLogo'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import { ProfileItem } from './utils/ProfileItem'

const AboutBlock = () => {
	return (
		<Box sx={{ width: '100%', minHeight: 'auto' }}>
			<ProfileItem>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<BarchartInfoLogo style={{ color: COLORS.secondaryFont }} />
						<TypographyHeader>О приложении</TypographyHeader>
					</Box>
					<TypographySecondary14>версия: 1.0</TypographySecondary14>
				</Box>
			</ProfileItem>
		</Box>
	)
}

export default AboutBlock
